// A daylight colour grade for the playable world, after filmic tone mapping.
// HUD text and account controls retain their own palette; nights keep moonlight.
export function gradeSurface(material, daylight) {
  if (!material || material.userData.islandPalette || !(material.isMeshStandardMaterial || material.isShaderMaterial)) return material;
  const compile = material.onBeforeCompile, key = material.customProgramCacheKey();
  material.userData.islandPalette = true;
  material.onBeforeCompile = function(shader, renderer) {
    compile.call(this, shader, renderer);
    shader.uniforms.uArtDaylight = daylight;
    shader.fragmentShader = 'uniform float uArtDaylight;\n' + shader.fragmentShader;
    shader.fragmentShader = shader.fragmentShader.replace('#include <colorspace_fragment>', `#include <colorspace_fragment>
      vec3 artRgb = pow(max(gl_FragColor.rgb, vec3(0.)), vec3(.78)) * 1.10;
      float artLuma = dot(artRgb, vec3(.2126,.7152,.0722));
      artRgb = mix(vec3(artLuma), artRgb, 1.28);
      gl_FragColor.rgb = mix(gl_FragColor.rgb, clamp(artRgb,0.,1.), clamp(uArtDaylight*1.7,0.,1.));`);
  };
  material.customProgramCacheKey = () => key + ':sunlit-palette-v1';
  material.needsUpdate = true;
  return material;
}

export function gradeWorld(root, daylight) {
  root.traverse(object => {
    if (!object.isMesh) return;
    for (const material of Array.isArray(object.material) ? object.material : [object.material]) gradeSurface(material, daylight);
  });
}
